import { render, staticRenderFns } from "./TextNoteBody.vue?vue&type=template&id=6e875cd8&"
import script from "./TextNoteBody.vue?vue&type=script&lang=js&"
export * from "./TextNoteBody.vue?vue&type=script&lang=js&"
import style0 from "./TextNoteBody.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports